import { Divider } from "@mui/material";

const CustomDivider = ({ orientation = "horizontal", flexItem = false, sx = {} , size }) => {
  return (
    <Divider
      orientation={orientation}
      flexItem={flexItem}
      sx={{
        ...(orientation === "vertical"
          ? { width: size || "30px", height: "auto" }
          : { height: size || "30px", width: "auto" }),
        border: "none", // Removes the default border
        ...sx, // Allows additional styles if needed
      }}
    />
  );
};

export const VerticalDivider = () => {
  return (
    <Divider
      orientation="vertical"
      flexItem
      sx={{ borderRight: "1px solid #B3B3B3" }} />
  );
}

export default CustomDivider;
